module.exports = __webpack_public_path__ + "static/media/SV1_06_ICantGiveEverythingAway_1000.4f7c191b.jpg";